import { cn } from '@/lib/utils'

export interface CountBadgeProps {
  count: number
  /** Visual style - 'primary' uses brand mint color */
  variant?: 'primary' | 'muted'
  /** Size variant */
  size?: 'sm' | 'md'
  className?: string
}

/**
 * Notification count badge for sidebar navigation and other UI elements.
 * Uses brand mint color by default for consistency.
 */
function CountBadge({
  count,
  variant = 'primary',
  size = 'md',
  className,
}: CountBadgeProps) {
  if (count <= 0) return null

  const displayCount = count > 99 ? '99+' : count

  return (
    <span
      className={cn(
        'flex items-center justify-center rounded-full font-medium tabular-nums',
        // Size variants
        size === 'sm' && 'h-4 min-w-4 px-1 text-[10px]',
        size === 'md' && 'h-5 min-w-5 px-1.5 text-xs',
        // Color variants
        variant === 'primary' && 'bg-primary text-primary-foreground',
        variant === 'muted' && 'bg-muted text-muted-foreground',
        className
      )}
    >
      {displayCount}
    </span>
  )
}

export { CountBadge }
